/*
 * @Author: cc
 * @LastEditTime: 2021-09-26 09:33:14
 */
import modify_left from "../../img/modifyPassword_left.png";
import "./modify-password.scss";
import { PassWord } from "../../components/index";
export default function ModifyPassWord() {
  return (
    <>
      <div className="modify_box">
        <img src={modify_left} alt="" />
        <div>
          <div className="submit_box">
            <a>
              提示：账号和密码在《医视在线平台》和《国家医学电子书包APP》通用
            </a>
            <PassWord />
          </div>
        </div>
      </div>
    </>
  );
}
